const getTopMarkers = (data) => {

    const orderedArray = data.sort((a, b) => b.count - a.count).splice(0, 6)

    return orderedArray

}


export default getTopMarkers